import React from "react";
import "./Modal.css";

/**
 * Modal component to load a popup window
 *
 * @property close default "Close" text for close button
 * @property onClose
 * @property onSubmit
 * @property submit default "Submit" text for submit button
 * @property title title on top of modal
 */
class Modal extends React.Component {
  componentWillMount() {
    document.addEventListener("keyup", e => {
      if (e.key === "Escape") {
        this.props.onClose();
      }
    });
  }

  render() {
    const {
      title,
      children,
      close = "Close",
      onClose,
      onSubmit,
      submit = "Submit"
    } = this.props;
    return (
      <div
        className="Modal"
        style={{ display: "block" }}
        tabIndex={0}
        onClick={e => {
          if (e.target.className === "Modal") {
            onClose();
          }
        }}
      >
        <div className="Modal__Dialog">
          <div className="Modal__Content">
            <div className="Modal__Header">
              <h3 className="Modal__Title">{title}</h3>
              <a onClick={onClose}>
                <span>&times;</span>
              </a>
            </div>
            <div className="Modal__Body">{children}</div>
            <div className="Modal__Footer">
              <button type="button" onClick={onClose}>
                {close}
              </button>
              <button type="button" onClick={onSubmit}>
                {submit}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js